import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilitaService } from '../../services/utilita.service';

@Component({
  selector: 'app-riepilogo-richiesta-adesione',
  templateUrl: './riepilogo-richiesta-adesione.component.html',
  styleUrls: ['./riepilogo-richiesta-adesione.component.css']
})
export class RiepilogoRichiestaAdesioneComponent implements OnInit {
  idNumeroPersone: any; //numero di persone aggiunte
  idutente: any
  lstElencoNominativi: any;
  idRichiesta: any;
  objdettaglio: any;
  objiscrizione: any;
  iId: any;
  objcalcolo: any;
  rigo: any;
  tipologia: any;
  sMessaggio: any = '';
  lstTipologiaRichiesta: any;
  idtipologiarichiesta: any
  idinscrittinominativi: any;
  selectedIds: any;
  objrichiesta: any;

  isEditTabella: number = 0;

  constructor(private srvUtilita: UtilitaService,
    private dialog: MatDialog, private router: Router, private route: ActivatedRoute,
    private snackBar: MatSnackBar) {

   

  }

  ngOnInit(): void {
    if (!this.srvUtilita.isUtenteLoggato()) {
      // this.router.navigate(['/auth/login']);
      this.router.navigate(['/accesso']);
    }

   


    this.idRichiesta = localStorage.getItem('idRichiesta') ; 
    this.getIscrizione();
    this.getListaNominativi();
    this.getProfiloUtente();
    this.getCalcolo();

    this.getRichiesta();

  }

  btnAnnulla() {
    this.router.navigate(['/dashboard/richiesta-adesione/']);
  }

  btnConfermaRichiestaAdesione() {
  
    this.router.navigate(['/dashboard/richiesta-adesione/riepilogo-richiesta-adesione/modalita-di-pagamento/']);

    const obj = {
      idRichiesta: this.idRichiesta,
      Importo: this.objcalcolo
    }
    console.log('obj', obj)
    
    this.srvUtilita.postObj('Utenti/PostConfermaRichiestaAdesione', obj).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')

    }, (err: any) => {
      this.showMessage('Errore: i dati non sono stati inseriti in modo corretto.', 'OK')
     // console.log(err.error.Message, 'ERRORE');
    })

  }

  getListaNominativi() {
    this.srvUtilita.getLista('Utenti/GetElencoNominativi?iIdRichiesta=' + this.idRichiesta).subscribe((res: any) => {
      this.lstElencoNominativi = res
    console.log('this.lstElencoNominativi', res)
      /* 
      for (this.rigo = 1; this.rigo < this.lstElencoNominativi.length + 1; this.rigo++) {
        let x = this.lstElencoNominativi[this.rigo];
        // console.log('rigo', x)

        if (this.rigo == '1') {
          this.sMessaggio = "Singolo";
          this.idtipologiarichiesta = 1;

        }

        if (this.rigo > '1') {
          this.sMessaggio = "Collettivo";
          this.idtipologiarichiesta = 2;
        }

        // this.idtipologiarichiesta = localStorage.setItem('Tipologia', this.idtipologiarichiesta)
      }*/

    }) 
  }

  getRichiesta() {
    this.srvUtilita.getObj('Utenti/GetRichiesta?idRichiesta=' + this.idRichiesta).subscribe((res: any) => {
      this.objrichiesta = res
      console.log(this.objrichiesta, 'objrichiesta')

      if (this.objrichiesta.idTipoAdesione == '1') {
        this.sMessaggio = "Singolo";

      }
      if (this.objrichiesta.idTipoAdesione > '1') {
        this.sMessaggio = "Collettivo";
      }
    })
  }

  /*
  getTipologiaRichiesta() {
    this.srvUtilita.getLista('Utenti/GetTipologiaRichiesta').subscribe((res: any) => {
      this.lstTipologiaRichiesta = res
      // console.log(res, 'res')


    })
  }*/

  getProfiloUtente() {
    this.idutente = JSON.parse(localStorage.getItem('username') || '0').idUtente;
    this.srvUtilita.getObj('Utenti/GetUtentiDettaglio?idUtentiProfilo=' + this.idutente).subscribe((res: any) => {
      this.objdettaglio = res
     // console.log(res, 'objdettaglio')
    })
  }

  getIscrizione() {
    this.srvUtilita.getObj('Utenti/getRichiestaIscrizione?iIdRichiesta=' + this.idRichiesta).subscribe((res: any) => {
      this.objiscrizione = res
      console.log(res.DescrizioneTipoAdesione, 'objiscrizione')
      console.log(res.idTipologiaRichiesta, 'id objiscrizione')

      if (this.objiscrizione.idTipologiaRichiesta == 2) {
        this.isEditTabella = 1;
      }

      if (this.objiscrizione.idTipologiaRichiesta == 0 || this.objiscrizione.idTipologiaRichiesta == 1) {
        this.isEditTabella = 0;
      }
    })
  }

 
  getCalcolo() {
    this.srvUtilita.getObj('Utenti/GetQuotaAnnuale?iIdRichiesta=' + this.idRichiesta).subscribe((res: any) => {
      this.objcalcolo = res
      console.log(res, 'res')
    })
  }

  

  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }

}
